"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONSchemer = void 0;
const index_js_1 = require("../../../schema/index.js");
const index_js_2 = require("./formattedItem/index.js");
class JSONSchemer extends index_js_1.SchemaAction {
    formattedItemSchema() {
        return (0, index_js_2.getFormattedItemJSONSchema)(this.schema);
    }
}
exports.JSONSchemer = JSONSchemer;
JSONSchemer.actionName = 'jsonSchemer';
